/* eslint-disable no-param-reassign */

import qs from 'qs';

import {MESSAGE_SENT} from '../data/messageTypes';

// `/api/messages` is rendered through the AMS json_api adapter, which emits top-level
// pagination `links` (`?page[number]=<last page>&page[size]=<per page>`). Same shape the
// points statement reads — `number` here is the LAST page number, i.e. the total page count.
const DEFAULT_PAGING = {number: 1, size: 12};

const parsePaging = (links) => {
  const last = links && links.last;

  if (!last || last.indexOf('?') === -1) {
    return DEFAULT_PAGING;
  }

  const {page} = qs.parse(last.split('?')[1]);

  if (!page) {
    return DEFAULT_PAGING;
  }

  return {
    number: parseInt(page.number, 10) || DEFAULT_PAGING.number,
    size: parseInt(page.size, 10) || DEFAULT_PAGING.size
  };
};

export const GET_SENT_MESSAGES_PENDING = 'GET_SENT_MESSAGES_PENDING';
export const GET_SENT_MESSAGES_FULFILLED = 'GET_SENT_MESSAGES_FULFILLED';
export const GET_SENT_MESSAGES_REJECTED = 'GET_SENT_MESSAGES_REJECTED';
export const POST_MESSAGES_PENDING = 'POST_MESSAGES_PENDING';
export const POST_MESSAGES_FULFILLED = 'POST_MESSAGES_FULFILLED';
export const POST_MESSAGES_REJECTED = 'POST_MESSAGES_REJECTED';
export const GET_MESSAGES_PENDING = 'GET_MESSAGES_PENDING';
export const GET_MESSAGES_FULFILLED = 'GET_MESSAGES_FULFILLED';
export const GET_MESSAGES_REJECTED = 'GET_MESSAGES_REJECTED';

export default function reducer(state = {
  fetching: false,
  fetched: false,
  sentFetching: false,
  sentFetched: false,
  errors: {},
  messages: [],
  sentMessages: [],
  paging: DEFAULT_PAGING,
  sentPaging: DEFAULT_PAGING,
  unreadMessagesCount: 0,
}, action) {
  switch (action.type) {
    case GET_MESSAGES_PENDING: {
      return {...state, fetching: true, fetched: false};
    }
    case GET_SENT_MESSAGES_PENDING: {
      return {...state, sentFetching: true, sentFetched: false};
    }
    case GET_MESSAGES_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        messages: action.payLoad.data,
        paging: parsePaging(action.payLoad.links),
      };
    }
    case GET_SENT_MESSAGES_FULFILLED: {
      return {
        ...state,
        sentFetching: false,
        sentFetched: true,
        sentMessages: action.payLoad.data,
        sentPaging: parsePaging(action.payLoad.links),
      };
    }
    case 'MARK_MESSAGES_FULFILLED': {
      const messages = [...state.messages];
      messages.forEach((message) => {
        if (action.payLoad.messageIds.find(id => id === message.id)) {
          message.attributes.read = action.payLoad.read;
        }
      });

      return {
        ...state,
        messages
      };
    }

    case 'DECREMENT_UNREAD_MESSAGE_COUNT': {
      return {
        ...state,
        unreadMessagesCount: state.unreadMessagesCount === 0 ? 0 : ((state.unreadMessagesCount - action.payLoad) || 0)
      };
    }

    case 'INCREMENT_UNREAD_MESSAGE_COUNT': {
      return {
        ...state,
        unreadMessagesCount: state.unreadMessagesCount === 0
          ? state.unreadMessagesCount : ((state.unreadMessagesCount + action.payLoad) || 0)
      };
    }
    case 'DELETE_MESSAGES_FULFILLED': {
      let {messages, sentMessages} = state;

      if (action.payLoad.type === MESSAGE_SENT) {
        sentMessages = state.sentMessages.filter(message => !action.payLoad.messageIds.find(id => id === message.id));
      } else {
        messages = state.messages.filter(message => !action.payLoad.messageIds.find(id => id === message.id));
      }

      return {
        ...state,
        messages,
        sentMessages
      };
    }
    case 'GET_MESSAGES_REJECTED': {
      return {...state, errors: action.payLoad.errors};
    }
    case 'GET_UNREAD_MESSAGE_COUNT': {
      return {...state, unreadMessagesCount: action.payLoad.unread_messages};
    }
    default:
  }

  return {...state};
}
